import PrivacyPolicy from './PrivacyPolicy';

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/pages/LegalDocuments/PrivacyPolicy/index.js